import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export const FREE_SHIPPING_THRESHOLD = 999;

export const cartKey = (item) => `${item.slug}::${item.variant_id || ""}`;

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("ee_cart")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("ee_cart", JSON.stringify(items));
  }, [items]);

  const add = (p, qty = 1) =>
    setItems((prev) => {
      const key = cartKey(p);
      const existing = prev.find((i) => cartKey(i) === key);
      if (existing) {
        return prev.map((i) => (cartKey(i) === key ? { ...i, qty: Math.min(i.qty + qty, 10) } : i));
      }
      return [
        ...prev,
        {
          slug: p.slug,
          variant_id: p.variant_id || null,
          variant_title: p.variant_title || "",
          name: p.name,
          price: p.price,
          image: p.image,
          qty,
        },
      ];
    });

  const remove = (key) => setItems((prev) => prev.filter((i) => cartKey(i) !== key));

  const setQty = (key, qty) =>
    setItems((prev) =>
      qty <= 0 ? prev.filter((i) => cartKey(i) !== key) : prev.map((i) => (cartKey(i) === key ? { ...i, qty } : i))
    );

  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.qty * i.price, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, count, subtotal, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
};
